import React, { Fragment } from "react";
import { Heading } from "@telia/teddy";

import cn from "classnames";
import _isEmpty from "lodash/isEmpty";
import { ExistingService } from "../../../../../../models/transfer";
import { getFormattedPrice } from "../../../../../../shared/priceFormatter";
import TRANSFER_TEXT from "../../../text-consts";
import "./RelatedServices.less";

interface RelatedServicesProps {
    services: ExistingService[];
}

const RelatedServices: React.FC<RelatedServicesProps> = ({ services }) => {
    if (_isEmpty(services)) {
        return <></>;
    }
    return (
        <div className="related-services">
            <Heading mb="100" as="h4" variant="title-300" className="related-services__title">
                {"Tilhørende avtaler"}
            </Heading>
            <div>
                <div>{TRANSFER_TEXT.SUMMARY.RELATED_INFORMATION.WILL_AUMATICALLY_TRANSFER}</div>
            </div>

            <div className={cn("related-services__table-container")}>
                {services.map(({ product, price }, i, arr) => (
                    <Fragment key={`related-services__table--item-${product}-${i}`}>
                        <span className="related-services__table-label">{product}</span>
                        <span className={cn("related-services__table-value")}>
                            {getFormattedPrice(price.monthly)}{" "}
                            {TRANSFER_TEXT.SUMMARY.SUBSCRIPTION_INFORMATION.PER_MONTH}
                        </span>
                        {arr.length - 1 !== i && <div className="related-services__table-hr"></div>}
                    </Fragment>
                ))}
            </div>
        </div>
    );
};

export default RelatedServices;
